var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0"},[(_vm.layer.render)?_c('img',{staticClass:"w-full h-full object-contain",attrs:{"src":_vm.layerSource,"alt":_vm.layer.name}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }